import NativeSelect from '@helvetia/components/forms/NativeSelect/NativeSelect'
import { Option } from '@helvetia/components/forms/NativeSelect/NativeSelect.types'
import { FieldProps } from 'formik'
import * as React from 'react'

interface Props {
  label?: string
  question?: string
  options: Option[]
  defaultSelected?: number | string
  required?: boolean
  onChange: (event) => void
}

interface State {
  selectedValue: number | string
}

export const toDropDownList = (entityObject): Option => {
  return { text: entityObject.name, value: Number(entityObject.id) }
}

export class DropDownSelect extends React.Component<Props & FieldProps, State> {
  state = {
    selectedValue: this.props.defaultSelected
      ? this.props.defaultSelected
      : this.props.options[0].value,
  }

  componentDidMount() {
    const option = this.props.options.find(
      option => option.value == this.props.defaultSelected,
    )
    this.props.form.setValues({
      ...this.props.form.values,
      [this.props.field.name]: option.value.toString(),
    })

    this.setState({ selectedValue: option.value.toString() })
  }

  handleSelectChange = event => {
    const { field, form } = this.props
    if (this.props.onChange) this.props.onChange(event)
    form.setValues({
      ...form.values,
      [field.name]: event.currentTarget.value,
    })
    this.setState({ selectedValue: event.currentTarget.value })
  }

  render() {
    const { label, question, field, form, options, required } = this.props
    const hasError = Boolean(
      form.touched[field.name] && form.errors[field.name],
    )
    const errorMsg = form.errors[field.name] as string
    return (
      <NativeSelect
        label={label ? label : ''}
        question={question}
        name={name}
        hasError={hasError}
        errorMsg={errorMsg}
        value={this.state.selectedValue}
        required={required}
        onChange={this.handleSelectChange}
        options={options}
      />
    )
  }
}
